import SectionSwitcher from './section-switcher';

//=============================================================================
// This will allow you to load content with ajax and inject it into the page.

// FOR LINKS
// Add a "js-ajax-load-link" class to the link. Add the correct url to the href.

// FOR FORMS (Ex: Search form)
// Add a "js-ajax-load-form" class to the form.

// ROUTES
// Create the appropriate template for the url route with {% layout none %}
// The template should be page-name.ajax.liquid. Ex: "collection.ajax.liquid"

// SECTIONS TO LOAD AJAX CONTENT INTO
// Add a class of js-ajax-load-section to any sections that will be affected.
// Assign a category to the affected sections with a data-ajax-type attribute.

// On the link/form, add a data-ajax-container attribute that corresponds to the
// data-ajax-type category of the section to add the content to.

// HIDING SECTIONS
// You can optionally hide sections when you load ajax content into other sections.
// On the link/form, add a data-ajax-hide attribute that corresponds to the
// data-ajax-type category of any sections to hide (optional).
//=============================================================================


export default class AjaxLoader {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        sectionSwitcher: new SectionSwitcher()
      };

      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Retrieves a template via ajax from link click
  //===========================================================================

  renderAjaxSectionFromLink(e) {
    const $target = $(e.currentTarget);
    const callback = $target.data('ajax-callback');
    const url = $target[0] ? $target[0].href : null;

    e.preventDefault();

    this.renderAjaxSection($target, url, callback);
  }

  //===========================================================================
  // Retrieves a template via ajax from form submission
  //===========================================================================

  renderAjaxSectionFromForm(e) {
    const $target  = $(e.currentTarget);
    const callback = $target.data('ajax-callback');
    const action   = $target[0] ? $target[0].action : '';
    const search   = $target.serialize();
    const url      = action + '?' + search;

    e.preventDefault();

    if (action && search) {
      this.renderAjaxSection($target, url, callback);
    }
  }

  //===========================================================================
  // Retrieves a template via ajax and injects it into the page.
  //===========================================================================

  renderAjaxSection($target, url, callback) {
    const $sections = $('.js-ajax-load-section');
    const containerType = $target.data('ajax-container');
    const hideType = $target.data('ajax-hide');
    const ajaxTemplate = $target.data('ajax-template') || 'ajax';
    const ajaxSearch = (url && url.indexOf('?') !== -1) ? `&view=${ ajaxTemplate }` : `?view=${ ajaxTemplate }`;
    const self = this;

    if (url && containerType) {
      $.ajax({
        url: url + ajaxSearch,
        type: 'GET',
        dataType: 'html',
        success: function (data) {
          const $template = $(data);

          $sections.each((i, el) => {
            const $el = $(el);
            const type = $el.data('ajax-type');

            if (type && type === hideType) {
              $el.addClass('hidden');
            } else if (type && type === containerType) {
              $el.empty().html($template.html()).removeClass('hidden');
            }

            if ($target.hasClass('js-ajax-section-switch')) {
              self.state.sectionSwitcher.switchSection($target);
            }
          });

          self.generalCallback(url);

          if (callback && typeof callback === 'function') {
            callback();
          } else if (callback && typeof callback === 'string') {
            $(document).trigger(callback);
          }
        },
        error: function(request, error) {
          console.log("Error: " + error);
        }
      });
    }
  }

  //===========================================================================
  // Callback for all loads
  //===========================================================================

  generalCallback(url) {
    const $links = $('.js-ajax-nav-link');

    $links.each((i, link) => {
      if (link.href === url) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });

    $(document).trigger('resetGrids');
    $(document).trigger('revealImages');
    $(document).trigger('reloadReviewsWidget');
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-ajax-load-link', this.renderAjaxSectionFromLink.bind(this));
    $(document).on('submit', '.js-ajax-load-form', this.renderAjaxSectionFromForm.bind(this));
  }
}
